export const branding = {
  primaryColor: '#cc2020',
};

// EN-30850: ZayZoon embedded employee widget loader script.
export const ZAYZOON_WIDGET_EMBED_SCRIPT_SRC = 'https://assets.zayzoon.com/public/widget_embed.js';

export const LoadTimeout: number = 500;

export enum Environments {
  Local = 'Local',
  QA = 'QA',
  DEV = 'Dev',
  Staging = 'Staging',
  Uat = 'Uat',
  Production = 'Production',
}
